import ProjectList from "@components/modules/projects/list";
import { NotFoundBrand } from "@components/widgets/ErrorPage";
import {
  ProjectsWhereColumn,
  useGetBrandForDocumentsQuery,
} from "@src/__generated__/graphql";
import { PageLoading } from "@src/components/modules/brands/page-loading";
import { NavigationBrand } from "@src/components/widgets/AppSubNav/NavigationBrand";
import { getQueryParam } from "@src/utils/routing";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";

export const PageProjects = observer(function PageProjects() {
  const { query } = useRouter();
  const brandId = getQueryParam("id", query);

  const { data, loading } = useGetBrandForDocumentsQuery({
    variables: { id: brandId },
  });

  if (loading) {
    return <PageLoading brandId={brandId} />;
  }

  if (!data?.brand) {
    return <NotFoundBrand />;
  }

  return (
    <main>
      <ProjectList
        brandId={brandId}
        hideFilters={[ProjectsWhereColumn.BrandId]}
        pageNavigation={<NavigationBrand id={brandId} variant="page" />}
      />
    </main>
  );
});
